import { render, staticRenderFns } from "./TrayInput.component.vue?vue&type=template&id=822bcd9e&scoped=true"
import script from "./TrayInput.component.vue?vue&type=script&lang=js"
export * from "./TrayInput.component.vue?vue&type=script&lang=js"
import style0 from "./TrayInput.component.vue?vue&type=style&index=0&id=822bcd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822bcd9e",
  null
  
)

export default component.exports